<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="visible"
    title="派单"
    width="60%">
    <span class="formContent">
       <el-form ref="rowInfo" :model="rowInfo" :rules="rules" label-width="150px">
         <el-row>
          <el-col :span="12">
            <el-form-item label="约车人">
              <span style="width: 200px">{{rowInfo.empName}}</span>
            </el-form-item>
          </el-col>
           <el-col :span="12">
            <el-form-item label="租车类型">
               <span style="width: 200px">{{rowInfo.orderTypeTxt}}</span>
            </el-form-item>
          </el-col>
         </el-row>
        <el-row>
         <el-col :span="12">
            <el-form-item label="所属公司">
              <span style="width: 200px">{{rowInfo.cusName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属城市">
               <span style="width: 200px">{{rowInfo.cityName}}</span>
            </el-form-item>
          </el-col>
       </el-row>
       <el-row>
          <el-col :span="12">
            <el-form-item label="租车数量">
               <span style="width: 200px">{{rowInfo.carNumber}}辆</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用车时间">
              <span style="width: 200px">{{rowInfo.carTime}}</span>
            </el-form-item>
          </el-col>
        </el-row>
       <el-row>
          <el-col :span="24">
            <el-form-item label="派单方式" prop="dispatchStatus">
               <select-text v-model="rowInfo.dispatchStatus" code-set-id="1007" placeholder="请选择派单方式" style="width: 500px" @selectChange="dispatchStatusChange"/>
            </el-form-item>
          </el-col>
        </el-row>
       <el-row>
          <el-col :span="24">
            <el-form-item :label="rowInfo.dispatchStatus=='10070002'?'抢单司机':'接单司机'" prop="orderDriver">
              <group-select-person v-model="rowInfo.checkDriver" :options="options"  :multiple="true" :clearable="true" style="width:500px"></group-select-person>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="color: #ff0000;">
            <el-form-item label="提醒">
               <p>1.派单方式为指定司机时，需选择指定的接单司机</p>
               <p>2.派单方式为抢单时，可选择指定范围的抢单司机，不选则默认该城市所有司机均可抢单</p>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </span>
    <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="submitForm('rowInfo')">确定</el-button>
        <el-button size="mini"  @click="closeForm">取消</el-button>
    </span>
  </el-dialog>
</template>
<script>
  import SelectText from '@/components/SelectText/index.vue'
  import groupSelectPerson from '@/components/select-person/index'
  import {
    getDriverByCityCode,
    getDynamicFormValue,
    disPatchOrder,
    getOrderDriverList,
    queryHasOrderByDriver,
    getDriverByProject
  } from "@/api/order/orderinfo"
  export default {
    components: { SelectText,groupSelectPerson },
    data() {
      return {
        visible: false,
        showViewer: false, // 显示查看器
        activeIndex: 0,
        id: '',
        title: '派单',
        rowInfo: {
          id:'',
          dispatchStatus:'',
          orderDriver:'',
          checkDriver:[],//接单司机
        },
        rules: {
          dispatchStatus: [{required: true, message: '请选择派单方式', trigger: 'change'}]
        },
        multiple:false,
        options: [],

      }
    },
    mounted() {
      // 加载参数
    },
    methods: {
      init(id) {
        this.visible = true
        this.rowInfo.id = id
        this.checkDriver=[]
        getDynamicFormValue(id).then((res) => {
          if(res.data.code==0){
            let data = res.data
            this.rowInfo = data.data
            if(data.data.parentId!='-1'&&data.data.orderDriver){
              var arr = [];
              arr.push(data.data.orderDriver)
              this.$set(this.rowInfo,'checkDriver',arr)
            }else if(data.data.parentId=='-1'&&data.data.carNumber==1&&data.data.orderDriver){
              var arr = [];
              arr.push(data.data.orderDriver)
              this.$set(this.rowInfo,'checkDriver',arr)
            }else if(data.data.parentId=='-1'&&data.data.carNumber!=1){
              //加载订单的当前司机
              getOrderDriverList(id).then((res) => {
                if (res.data.code == 0) {
                  let driverIds = [];
                  res.data.data.forEach(item=>{
                    driverIds.push(item.id)
                  })
                  this.$set(this.rowInfo,'checkDriver',driverIds)
                }
              })
            }
            console.log(JSON.stringify(this.rowInfo.checkDriver))
            if(data.data.isHighSeas=='10060001'){
              let cityCode = data.data.cityCode
              this.getDriverByCityCode(cityCode)
            }else{
              let cusId = data.data.cusId
              this.getDriverByCusId(cusId)
            }
          }
        })
      },
      //加载司机根据城市加载司机
      getDriverByCityCode(cityCode){
        getDriverByCityCode({cityCode:cityCode}).then((res) => {
          if (res.data.code == 0) {
            let data = res.data
            this.options = data.data
          }
        })
      },
      //根据项目
      getDriverByCusId(cusId){
        getDriverByProject({cusId:cusId}).then((res) => {
          if (res.data.code == 0) {
            let data = res.data
            this.options = data.data
          }
        })
      },
      submitForm(formName) {
        console.log(this.rowInfo.checkDriver)
        this.$set(this.rowInfo,'orderDriver',this.rowInfo.checkDriver.join(','))
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let orderDriverIds = this.rowInfo.orderDriver
            this.rowInfo.orderDriverIds = orderDriverIds
            if(this.rowInfo.dispatchStatus=='10070001'){
                let carDate = this.rowInfo.carTime.split(' ')[0]
                //指定司机
                queryHasOrderByDriver({orderId:this.rowInfo.id,driverIds:orderDriverIds,carDate:carDate}).then((res) => {
                  if(res.data.code == 0) {
                    if(res.data.data.length==0){
                      this.$confirm('确定要派单吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                      }).then(() => {
                        this.saveOrder()
                      })
                    }else{
                      let driverList = res.data.data;
                      let driverNameList = [];
                      driverList.forEach(item=>{
                        driverNameList.push(item.driverName)
                      })
                      this.$confirm(driverNameList.join(",")+'在'+carDate+'已有行程，确定要派单吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                      }).then(() => {
                        this.saveOrder()
                      })
                    }
                  }
                })
            }else{
              this.$confirm('确定要派单吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.saveOrder()
              })
            }
          } else {
            return false
          }
        })
      },
      //保存订单
      saveOrder(){
        disPatchOrder(this.rowInfo).then((res) => {
          if(res.data.code==0){
            // 在store中改变修改的值
            this.$message.success("派单成功")
            // 子组件中触发父组件的初始化方法
            this.$emit('refresh', '')
            // 关闭弹框
            this.closeForm()
          }else{
            this.$message.error(res.data.msg)
          }
        })
      },
      dispatchStatusChange(){
       if(this.rowInfo.dispatchStatus=='10070001'){
          //接单
          this.$set(this.rules,'orderDriver',[{required: true, validator: this.validateMultiple,trigger: 'change'}])
        }else{
          this.$set(this.rules,'orderDriver',[{required: false, validator: this.validateMultiple,trigger: 'change'}])
        }
      },
      validateMultiple(rule, value, callback) {
        if(this.rowInfo.checkDriver instanceof Array){
          if(this.rowInfo.dispatchStatus=='10070001') {
            if (this.rowInfo.checkDriver.length != this.rowInfo.carNumber) {
              callback(new Error('该行程需指定' + this.rowInfo.carNumber + '名司机'))
            }
          }
        }else if(this.rowInfo.checkDriver.length==0){
          if(this.rowInfo.dispatchStatus=='10070001') {
            callback(new Error('该行程需指定' + this.rowInfo.carNumber + '名司机'))
          }
        }
        callback()
      },
      closeForm() {
        this.visible = false
        // 重置表单
        this.$refs['rowInfo'].resetFields()
        this.rowInfo = {
          id:'',
          dispatchStatus:'',
          orderDriver:''
        }
      }
    }
  }
</script>
<style scoped  rel="stylesheet/scss">
  .backBox{
    /*margin-bottom: 20px;*/
  }
  .goback{
    width: 70px;
    padding:8px;
    border:1px solid #cccccc;
    color:#cccccc;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    line-height: 16px;
    font-size: 14px;
    cursor: pointer;
  }
  .goback:hover{
    border:1px solid #269cff;
    color:#269cff;
  }
  .batchBoxTitle{
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    line-height: 40px;
  }
  .footer{
    position: fixed;
    bottom: 10px;
    left: 50%;
  }
</style>
